export default __webpack_public_path__ + "static/media/plus.e3bf2231.svg";